export default __webpack_public_path__ + "static/media/work3.76f03a8a.jpeg";